import React, { Component } from 'react'
import { render } from 'react-dom'
import PSaleBook from './PSaleBook'

class Demo extends Component {
	constructor(props) {
		super(props)						
	}

	render() {
		return (	            
			<PSaleBook />
		)			
	}	
}

render(<Demo />, document.getElementById('content'))


// WEBPACK FOOTER //
// ./js/src/pages/PSaleBook/index.js